import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-auto border border-dark-gray-200 bg-white" }
const _hoisted_2 = {
  class: "w-full border-collapse text-sm",
  style: {"table-layout":"fixed"}
}
const _hoisted_3 = { class: "bg-dark-gray-200" }
const _hoisted_4 = { class: "sticky left-0 z-20 border-b border-r border-dark-gray-200 bg-dark-gray-200 px-3 py-2 text-left font-semibold" }
const _hoisted_5 = {
  class: "sticky z-20 border-b border-r border-dark-gray-200 bg-dark-gray-200 px-3 py-2 text-left font-semibold",
  style: {"left":"20rem"}
}
const _hoisted_6 = { class: "bg-dark-gray-100" }
const _hoisted_7 = { class: "sticky left-0 z-10 border-b border-r border-dark-gray-200 bg-dark-gray-100 px-3 py-2 font-semibold text-dark-gray-800" }
const _hoisted_8 = { class: "sticky left-0 z-10 border-b border-r border-dark-gray-200 bg-white px-3 py-1.5 text-dark-gray-800" }
const _hoisted_9 = {
  class: "sticky z-10 border-b border-r border-dark-gray-200 bg-white px-3 py-1.5 text-dark-gray-600",
  style: {"left":"20rem"}
}
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipTrigger = _resolveComponent("TooltipTrigger")!
  const _component_TooltipContent = _resolveComponent("TooltipContent")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_TooltipProvider = _resolveComponent("TooltipProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("colgroup", null, [
        _cache[0] || (_cache[0] = _createElementVNode("col", { style: {"width":"20rem"} }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("col", { style: {"width":"6rem"} }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
          return (_openBlock(), _createElementBlock("col", {
            key: `col-${column.key}`,
            style: {"width":"10rem"}
          }))
        }), 128))
      ]),
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('views.farmToFarm.table.labelHeader')), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('views.farmToFarm.table.unitHeader')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("th", {
              key: `head-${column.key}`,
              class: _normalizeClass(["border-b border-dark-gray-200 px-3 py-2 text-right font-semibold", { 'bg-white': column.isAggregate }])
            }, _toDisplayString(column.name), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.groups, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: group.key
          }, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(group.header), 1),
              _cache[2] || (_cache[2] = _createElementVNode("td", {
                class: "sticky z-10 border-b border-r border-dark-gray-200 bg-dark-gray-100",
                style: {"left":"20rem"}
              }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `grouphead-${group.key}-${column.key}`,
                  class: "border-b border-dark-gray-200"
                }))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.field_key,
                class: "hover:bg-dark-gray-100"
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(row.label), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(row.unit), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `${row.field_key}-${column.key}`,
                    class: _normalizeClass(["border-b border-dark-gray-200 px-3 py-1.5 text-right tabular-nums", _ctx.cellClass(column)])
                  }, [
                    (column.note)
                      ? (_openBlock(), _createBlock(_component_TooltipProvider, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Tooltip, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_TooltipTrigger, { "as-child": "" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatCell(row, column)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_TooltipContent, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(column.note), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatCell(row, column)), 1))
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}